import { render, staticRenderFns } from "./ConfirmLeave.pug?vue&type=template&id=560baa2c&lang=pug&"
import script from "./ConfirmLeave.vue?vue&type=script&lang=js&"
export * from "./ConfirmLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports